import { render, staticRenderFns } from "./AddProfileStoc.vue?vue&type=template&id=5bd899c0&scoped=true"
import script from "./AddProfileStoc.vue?vue&type=script&lang=js"
export * from "./AddProfileStoc.vue?vue&type=script&lang=js"
import style0 from "./AddProfileStoc.vue?vue&type=style&index=0&id=5bd899c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd899c0",
  null
  
)

export default component.exports